<template>
  <router-view />
</template>

<style lang="scss">
// * {
//   margin: 0;
//   padding: 0;
//   list-style: none;

// }
// a{
//     text-decoration: none;
// }
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

// ul {
//   list-style-type: none;
//   padding: 0px;
//   margin: 0px;
// }
@font-face {
  font-family: 'Regular';
  /* 字体名称 */
  src: url('@/assets/fonts/SiYuanHeiTiJiuZiXing-Regular-2.ttf');
  /* 字体文件的路径和格式 */
  /* 可以添加其他属性，如 font-weight 和 font-style */
}

@font-face {
  font-family: 'Bold';
  /* 字体名称 */
  src: url('@/assets/fonts/SourceHanSansSC-Bold-2.otf');
  /* 字体文件的路径和格式 */
  /* 可以添加其他属性，如 font-weight 和 font-style */
}
@font-face {
  font-family: 'SplashInk';
  /* 字体名称 */
  src: url('@/assets/fonts/三极泼墨体.ttf');
  /* 字体文件的路径和格式 */
  /* 可以添加其他属性，如 font-weight 和 font-style */
}

@font-face {
  font-family: 'Huayuan';
  /* 字体名称 */
  src: url('@/assets/fonts/Huayuan.Gothic.Regular.ttf');
  /* 字体文件的路径和格式 */
  /* 可以添加其他属性，如 font-weight 和 font-style */
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: Regular;
}

a {
  text-decoration: none;
}

</style>
